export default "__VITE_ASSET__8atKX4k9__"